import { CompanyDto } from "#modules/company/infra/Company.dto";
import { CompanyTypeSchema, PartTypeSchema } from "shared";

export const getDefaultPartTypeToSearchFor = (company?: CompanyDto | null) => {
  if (!company) {
    return null;
  }

  return company.companySettings.companyType === CompanyTypeSchema.enum.SHEET
    ? PartTypeSchema.enum.SHEET
    : company.companySettings.companyType === CompanyTypeSchema.enum.MACHINING
      ? PartTypeSchema.enum.MACHINING
      : company.companySettings.companyType === CompanyTypeSchema.enum.TURNING
        ? PartTypeSchema.enum.ROUND_BAR
        : PartTypeSchema.enum.OTHER;
};
